import { component } from 'picoapp'

export default component((node,ctx) => {
  const currentGender = localStorage.getItem('spreeglee_gender') || 'unisex'
  if (currentGender === 'unisex') {
    window.location.href = '/?cart=true'
  } else {
    window.location.href = `${window.theme.homePages[currentGender]}?cart=true`
  }
})